/* Konfigurator JS: IIFE + safety checks + sold-out-last + sold-out hint
   + backwards defaults + DOM reorder + block selecting sold-out tiles */
(function () {
  'use strict';

  let result;

  // -------------------------------- UI Helpers --------------------------------
  const changeVariants = function (evt, variant) {
    let i;
    const tabcontent = document.querySelectorAll('.product-thumbnails .tabcontent');
    if (tabcontent && tabcontent.length) {
      for (i = 0; i < tabcontent.length; i++) tabcontent[i].style.display = 'none';
    }
    if (variant == 'muenzfach') {
      document.querySelector("[tab_data='farbe']").classList.add('in-active');
      document.querySelector("[tab_data='modell']").classList.add('in-active');

    } else if (variant == 'modell') {
      document.querySelector("[tab_data='farbe']").classList.remove('in-active');
    } else if (variant == 'farbe') {
      document.querySelector("[tab_data='modell']").classList.add('in-active');
    }

    const tablinks = document.getElementsByClassName('tablinks');
    if (tablinks && tablinks.length) {
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '');
      }
    }

    const pane = document.getElementById(variant);
    if (pane) {
      pane.style.display = 'block';
      requestAnimationFrame(() => {
        reorderSoldOutToEnd(pane);
        refreshVisibleSwipers(pane);
      });
    }

    const currentTab = evt && evt.currentTarget ? evt.currentTarget : null;

    if (currentTab && currentTab.getAttribute('tab_data') == 'muenzfach') {
      const nextBtn = document.querySelector('.Konfigurator_next_btn');
      // const cartBtn = document.querySelector('.cart__btn');
      const cartBtn = document.querySelector('.custom-add-to-cart-btn-os');
      if (nextBtn) nextBtn.style.display = 'none';
      if (cartBtn) cartBtn.style.setProperty('display', 'flex', 'important');
    } else {
      const nextBtn = document.querySelector('.Konfigurator_next_btn');
      // const cartBtn = document.querySelector('.cart__btn');
      const cartBtn = document.querySelector('.custom-add-to-cart-btn-os');
      if (nextBtn) nextBtn.style.display = 'flex';
      if (cartBtn) cartBtn.style.setProperty('display', 'none', 'important');
    }

    if (currentTab) {
      if (currentTab.classList.contains('in-active')) currentTab.classList.remove('in-active');
      currentTab.classList.add('active');
    }
  };
  window.changeVariants = changeVariants; // keep callable from HTML

  const showAndHideSiblings = (element) => {
    if (!element || !element.parentNode) return;
    const siblings = element.parentNode.children;
    for (let i = 0; i < siblings.length; i++) {
      siblings[i].style.display = siblings[i] === element ? 'block' : 'none';
    }
  };

  function toggleActive(selectedBtnId) {
    const buttons = document.querySelectorAll('.toggle-btn');
    if (!buttons || !buttons.length) return;
    buttons.forEach((btn) => {
      if (btn.id === selectedBtnId) btn.classList.add('active');
      else btn.classList.remove('active');
    });
  }

  // -------------------------------- Data Fetch --------------------------------
  const order = ["ohne", "Mini", "XL", "XXL"];

  async function fetchresult() {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('X-Shopify-Storefront-Access-Token', 'b4559b831b5075967f8a18b26ef5feb5');

    const graphql = JSON.stringify({
      query: `query MyQuery {
        products(first: 250) {
          nodes {
            id
            title
            metafields(identifiers: [
              {key: "Lederart", namespace: "Konfigurator"},
              {key: "Verschlusssystem", namespace: "Konfigurator"}, 
              {key: "Frontdesign", namespace: "Konfigurator"},
              {key: "Muenzfach", namespace: "Konfigurator"}
            ]) { id key namespace value }
            productFeatureList: metafield(namespace: "custom", key: "product_feature_list") {
              type
              references(first: 50) {
                nodes {
                  ... on Metaobject {
                    id
                    type
                    handle
                    fields {
                      key
                      value
                      reference {
                        ... on MediaImage {
                          id
                          image {
                            url
                            altText
                            width
                            height
                          }
                        }
                      }
                    }
                  }
                }
              }
              reference {
                ... on Metaobject {
                  id
                  type
                  handle
                  fields {
                    key
                    value
                    reference {
                      ... on MediaImage {
                        id
                        image { url altText width height }
                      }
                    }
                  }
                }
              }
            }
            images(first: 50) { nodes { url(transform: {}) altText } }
            tags
            variants(first: 50) {
              edges { node {
                currentlyNotInStock
                availableForSale
                sku
                id
                image { url altText }
                selectedOptions { value name }
                price { amount currencyCode }
                compareAtPrice { amount currencyCode }
              } }
            }
            options(first: 100) {
              name id values
              optionValues { name swatch { image { mediaContentType alt previewImage { url } } } }
            }
            handle
          }
        }
      }`
    });

    const requestOptions = { method: 'POST', headers: myHeaders, body: graphql, redirect: 'follow' };

    try {
      const response = await fetch('/api/2025-07/graphql.json', requestOptions);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  }

  // -------------------------------- Utils --------------------------------
  const SOLDOUT_HINT_TEXT = "sold-out state → sold-out variants are shown last";
  function buildSoldOutHintHTML() {
    return `
      <div class="soldout-hint" role="status" aria-live="polite">
        <span class="hint-avatar">L</span>
        <span class="hint-text">${SOLDOUT_HINT_TEXT}</span>
      </div>
    `;
  }

  function formatPrice(amount, currencyCode = 'EUR') {
    if (!amount && amount !== 0) return '';
    const price = parseFloat(amount);
    if (Number.isNaN(price)) return '';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currencyCode }).format(price);
  }

  function calculateDiscount(price, compareAtPrice) {
    if (!price || !compareAtPrice) return 0;
    const p = parseFloat(price);
    const c = parseFloat(compareAtPrice);
    if (!(c > 0)) return 0;
    return Math.round(((c - p) / c) * 100);
  }

  const slugify = (str) =>
    (str || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

  // [OPT-2] Shopify CDN thumbnail sizing: request a small image instead of the full 2500×2500px source
  function thumbnailUrl(url, size = 200) {
    if (!url) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}width=${size}`;
  }

  // [OPT-1] Single loader: hide the overlay once data + initial images are truly ready
  // ── Loader animation: RAF-driven rotation + real progress fill ──────────────
  // Runs from page-load until hideLoader() is called.
  // Uses SVG attribute transforms (not CSS) for cross-browser reliability.
  const _loader = (() => {
    const CIRCUMFERENCE_R90 = 2 * Math.PI * 90; // 565.49 — desktop (r=90)
    const CIRCUMFERENCE_R65 = 2 * Math.PI * 65; // 408.41 — mobile  (r=65)

    let _angle      = -90;   // current rotation angle in degrees
    let _progress   = 0;     // 0–100, smoothly animated
    let _target     = 5;     // target progress (set by setProgress)
    let _rafId      = null;
    let _running    = false;

    function _circumference() {
      return window.innerWidth <= 768 ? CIRCUMFERENCE_R65 : CIRCUMFERENCE_R90;
    }

    function _tick() {
      if (!_running) return;

      // Smooth rotation: 360° / 1.3 s ≈ 277°/s; at 60fps ≈ 4.6° per frame
      _angle = (_angle + 4.6) % 360;

      // Smooth progress: ease toward target
      const diff = _target - _progress;
      if (Math.abs(diff) > 0.1) _progress += diff * 0.06;
      else _progress = _target;

      const spinner = document.getElementById('bd-ring-spinner');
      const fill    = document.getElementById('bd-progress-ring-fill');

      if (spinner) {
        // SVG attribute transform — works in every browser including old Safari
        spinner.setAttribute('transform', `rotate(${_angle.toFixed(1)} 100 100)`);
      }
      if (fill) {
        const c   = _circumference();
        const off = c - (_progress / 100) * c;
        fill.style.strokeDasharray  = c;
        fill.style.strokeDashoffset = off.toFixed(2);
      }

      _rafId = requestAnimationFrame(_tick);
    }

    return {
      start() {
        if (_running) return;
        _running = true;
        _rafId   = requestAnimationFrame(_tick);
      },
      setProgress(pct) {
        _target = Math.min(100, Math.max(_target, pct)); // only move forward
      },
      stop() {
        _running = false;
        if (_rafId) { cancelAnimationFrame(_rafId); _rafId = null; }
      }
    };
  })();

  // Tracks whether the loading overlay is still visible.
  // syncImgAttributes uses this to skip the async preload during init.
  let _loaderVisible = true;

  function hideLoader() {
    _loaderVisible = false;
    _loader.setProgress(100);
    // Small delay so the user sees 100% before fade-out
    setTimeout(() => {
      _loader.stop();
      const loadingScreen = document.getElementById('bd-loading-screen');
      const mainContent   = document.getElementById('bd-main-content');
      if (loadingScreen) {
        loadingScreen.classList.add('bd-fade-out');
        setTimeout(() => { loadingScreen.style.display = 'none'; }, 400);
      }
      if (mainContent) {
        mainContent.classList.remove('bd-hidden');
        mainContent.style.opacity  = '1';
        mainContent.style.animation = 'none';
        mainContent.style.transform = 'none';
      }
      document.body.style.overflow = 'auto';
    }, 300);
  }

  // Wait until ALL thumbnail images (all tabs) + the main preview have finished loading.
  // Thumbnails in hidden tabs may have loading="lazy" so the browser hasn't fetched them yet —
  // we force them to eager here so they download in the background while the loader is still up.
  function waitForInitialImages(onProgress) {
    return new Promise((resolve) => {
      document.querySelectorAll(
        '#modell img, #farbe img, #muenzfach img, #lederart img'
      ).forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager';
      });

      const imgs = Array.from(document.querySelectorAll(
        '#modell img, #farbe img, #muenzfach img, #lederart img, .main-product-img'
      ));

      if (!imgs.length) return resolve();

      const total = imgs.length;
      let loaded  = 0;

      const timeout = setTimeout(resolve, 5000);

      const done = () => {
        loaded++;
        if (onProgress) onProgress(loaded, total);
        if (loaded >= total) {
          clearTimeout(timeout);
          resolve();
        }
      };

      imgs.forEach((img) => {
        if (img.complete && img.naturalWidth > 0) { done(); return; }
        img.addEventListener('load',  done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
    });
  }

  // === SOLD-OUT LAST (data-level): stable sort used everywhere ===
  function sortProductsByAvailability(arr) {
    if (!Array.isArray(arr)) return [];
    return arr
      .map((item, idx) => ({ item, idx }))
      .sort((a, b) => {
        const isSoldOut = (v) => {
          const av = Boolean(v?.availableForSale);
          const nis = Boolean(v?.currentlyNotInStock);
          return !av || nis;
        };
        const aSold = isSoldOut(a.item) ? 1 : 0;
        const bSold = isSoldOut(b.item) ? 1 : 0;

        if (aSold !== bSold) return aSold - bSold; // in-stock first

        const aPrice = parseFloat(a.item?.variantPrice ?? a.item?.price?.amount ?? Number.POSITIVE_INFINITY);
        const bPrice = parseFloat(b.item?.variantPrice ?? b.item?.price?.amount ?? Number.POSITIVE_INFINITY);
        if (Number.isFinite(aPrice) && Number.isFinite(bPrice) && aSold === 0) {
          if (aPrice !== bPrice) return aPrice - bPrice;
        }
        return a.idx - b.idx; // stable tie-break
      })
      .map(({ item }) => item);
  }

  // === SOLD-OUT LAST (DOM-level): reorder already-rendered tiles so sold-outs are last ===
  function reorderSoldOutToEnd(scope = document) {
    const containers = scope.querySelectorAll('.filter__data');
    if (!containers.length) return;

    containers.forEach((container) => {
      const wrapper = container.classList.contains('swiper')
        ? container.querySelector('.swiper-wrapper')
        : container;
      if (!wrapper) return;

      const children = Array.from(wrapper.children).filter((node) =>
        node.classList.contains('swiper-slide') || node.classList.contains('slider__data')
      );
      if (!children.length) return;

      const getTileRoot = (node) =>
        node.classList.contains('swiper-slide') ? (node.querySelector('.slider__data') || node) : node;

      const inStock = [];
      const soldOut = [];

      children.forEach((node) => {
        const tile = getTileRoot(node);
        const product = tile.querySelector('.product-item');
        const isSold = product?.classList.contains('sold-out');
        (isSold ? soldOut : inStock).push(node);
      });

      [...inStock, ...soldOut].forEach((n) => wrapper.appendChild(n));
      if (container._swiper) { try { container._swiper.update(); } catch (_) { } }
    });
  }

  // Availability helpers
  function isTileInStock(tile) {
    const img = tile && tile.querySelector('img');
    if (!img) return false;
    const available = String(img.dataset.available || '') === 'true';
    const inStock = String(img.dataset.inStock || '') === 'true';
    return available && inStock;
  }
  function isSoldOutTile(tile) {
    const el = tile && tile.querySelector('.product-item');
    return !!el && el.classList.contains('sold-out');
  }
  function clickFirstAvailable(container) {
    if (!container) return;
    const tiles = container.querySelectorAll('.slider__data');
    if (!tiles.length) return;
    const firstAvailable = Array.from(tiles).find(isTileInStock) || tiles[0];
    container.querySelectorAll('.slider__data').forEach((n) => n.classList.remove('active'));
    firstAvailable.classList.add('active');
    firstAvailable.click();
  }

  // -------------------------------- Swiper Helpers --------------------------------
  function makeSwiperContainer(extraClasses = '') {
    const container = document.createElement('div');
    container.className = `filter__data swiper ${extraClasses}`.trim();

    const track = document.createElement('div');
    track.className = 'swiper-wrapper';
    container.appendChild(track);

    const prev = document.createElement('div');
    prev.className = 'swiper-button-prev';
    const next = document.createElement('div');
    next.className = 'swiper-button-next';
    container.appendChild(prev);
    container.appendChild(next);

    return { container, track, prev, next };
  }

  function initSwipers(scope = document) {
    if (typeof Swiper === 'undefined') {
      console.error('Swiper not found.');
      return;
    }
    const blocks = scope.querySelectorAll('.filter__data.swiper');
    if (!blocks || !blocks.length) return;

    blocks.forEach((el) => {
      const isMuenzfach = el.classList.contains('muenzfach');
      const slideCount = el.querySelectorAll('.swiper-slide').length;

      if (el._swiper) {
        try { el._swiper.update(); } catch (_) { }
        return;
      }

      el._swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        centerInsufficientSlides: true,
        centeredSlides: false,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
      });

      // swiper.on('afterInit', () => {
      //   if (swiper.isLocked) {
      //     swiper.params.centeredSlides = true;
      //     swiper.update();
      //   }
      // });

    });
  }

  function refreshVisibleSwipers(scope = document) {
    const swipers = scope.querySelectorAll('.filter__data.swiper');
    if (!swipers || !swipers.length) return;
    swipers.forEach((el) => {
      const s = el._swiper;
      if (!s) return;
      if (el.offsetParent !== null) {
        try {
          s.updateSize(); s.updateSlides(); s.updateProgress(); s.update(); s.slideTo(0, 0);
        } catch (_) { }
      }
    });
  }

  // -------------------------------- Data Builder (Tree) --------------------------------
  function filteredJsonData(metafield) {
    if (!metafield?.data?.products?.nodes) {
      console.error('Invalid data format');
      return {};
    }

    const tree = {};

    metafield.data.products.nodes.sort((a, b) => {
      // find the Muenzfach metafield inside each product
      const mfA = a.metafields?.find(m => m.key === "Muenzfach");
      const mfB = b.metafields?.find(m => m.key === "Muenzfach");

      // find the custom order index
      const aIndex = mfA ? order.findIndex(o => mfA.value.startsWith(o)) : Infinity;
      const bIndex = mfB ? order.findIndex(o => mfB.value.startsWith(o)) : Infinity;

      return aIndex - bIndex;
    }).forEach((product) => {
      const metafields = product.metafields || [];
      const image = product.images?.nodes?.[0];
      const options = product.options || [];
      const allVariants = product.variants?.edges?.map((edge) => edge.node) || [];

      const sortedVariants = sortProductsByAvailability(allVariants);
      const defaultVariant = sortedVariants.find((v) => v.availableForSale) || sortedVariants[0];

      let frontdesign = null;
      let verschluss = null;
      let lederart = null;
      let muenzfach = null;

      metafields.forEach((field) => {
        if (field?.key === 'Frontdesign') frontdesign = field.value;
        if (field?.key === 'Verschlusssystem') verschluss = field.value;
        if (field?.key === 'Lederart') lederart = field.value;
        if (field?.key === 'Muenzfach') muenzfach = field.value;
      });

      if (!frontdesign || !verschluss) return;

      if (!tree[frontdesign]) tree[frontdesign] = { Verschlusssystem: {} };
      if (!tree[frontdesign].Verschlusssystem[verschluss]) {
        tree[frontdesign].Verschlusssystem[verschluss] = { _products: [], Lederart: {} };
      }

      const verschlussNode = tree[frontdesign].Verschlusssystem[verschluss];

      // model-level card
      verschlussNode._products.push({
        id: product.id,
        handle: product.handle,
        title: product.title,
        imageUrl: image?.url || null,
        imageAlt: image?.altText || null,
        variantId: defaultVariant?.id || null,
        variantSku: defaultVariant?.sku || null,
        variantPrice: defaultVariant?.price?.amount || null,
        compareAtPrice: defaultVariant?.compareAtPrice?.amount || null,
        currencyCode: defaultVariant?.price?.currencyCode || 'EUR',
        availableForSale: defaultVariant?.availableForSale || false,
        currentlyNotInStock: defaultVariant?.currentlyNotInStock || false
      });

      // Lederart
      if (lederart) {
        if (!verschlussNode.Lederart[lederart]) {
          verschlussNode.Lederart[lederart] = { _products: [], options: { Farbe: {} } };
        }

        const lederartNode = verschlussNode.Lederart[lederart];

        lederartNode._products.push({
          id: product.id,
          handle: product.handle,
          title: product.title,
          imageUrl: image?.url || null,
          imageAlt: image?.altText || null,
          variantId: defaultVariant?.id || null,
          variantSku: defaultVariant?.sku || null,
          variantPrice: defaultVariant?.price?.amount || null,
          compareAtPrice: defaultVariant?.compareAtPrice?.amount || null,
          currencyCode: defaultVariant?.price?.currencyCode || 'EUR',
          availableForSale: defaultVariant?.availableForSale || false,
          currentlyNotInStock: defaultVariant?.currentlyNotInStock || false
        });

        // Farbe options
        options.forEach((option) => {
          const { name, values } = option;
          if (name === 'Farbe' || name === 'Color') {
            values.forEach((value) => {
              if (!lederartNode.options.Farbe[value]) {
                lederartNode.options.Farbe[value] = {
                  products: [],
                  variantImage: null,
                  variantSku: null,
                  variantId: null,
                  variantPrice: null,
                  compareAtPrice: null,
                  currencyCode: null,
                  handle: null,
                  availableForSale: false,
                  currentlyNotInStock: false,
                  Muenzfach: {}
                };
              }

              const matchedVariant = sortedVariants.find((v) =>
                v.selectedOptions.some((o) => o.name === name && o.value === value)
              );

              if (matchedVariant) {
                const filteredProduct = {
                  id: product.id,
                  handle: product.handle,
                  title: product.title,
                  variantId: matchedVariant.id,
                  sku: matchedVariant.sku || null,
                  variantImage: matchedVariant.image?.url || null,
                  selectedOptions: matchedVariant.selectedOptions,
                  variantPrice: matchedVariant?.price?.amount || null,
                  compareAtPrice: matchedVariant?.compareAtPrice?.amount || null,
                  currencyCode: matchedVariant?.price?.currencyCode || 'EUR',
                  availableForSale: matchedVariant?.availableForSale || false,
                  currentlyNotInStock: matchedVariant?.currentlyNotInStock || false
                };

                const optionLevel = lederartNode.options.Farbe[value];
                optionLevel.products.push(filteredProduct);

                if (!optionLevel.variantImage) {
                  optionLevel.variantImage = matchedVariant.image?.url || null;
                  optionLevel.variantId = matchedVariant.id;
                  optionLevel.variantSku = matchedVariant?.sku;
                  optionLevel.handle = product.handle;
                  optionLevel.variantPrice = matchedVariant?.price?.amount || null;
                  optionLevel.compareAtPrice = matchedVariant?.compareAtPrice?.amount || null;
                  optionLevel.currencyCode = matchedVariant?.price?.currencyCode || 'EUR';
                  optionLevel.availableForSale = matchedVariant?.availableForSale || false;
                  optionLevel.currentlyNotInStock = matchedVariant?.currentlyNotInStock || false;
                }

                // Muenzfach
                if (muenzfach) {
                  if (!optionLevel.Muenzfach[muenzfach]) {
                    optionLevel.Muenzfach[muenzfach] = {
                      products: [],
                      variantImage: null,
                      variantSku: null,
                      variantId: null,
                      handle: product.handle,
                      variantPrice: null,
                      compareAtPrice: null,
                      currencyCode: null,
                      availableForSale: false,
                      currentlyNotInStock: false
                    };
                  }

                  const muenzfachNode = optionLevel.Muenzfach[muenzfach];
                  muenzfachNode.products.push(filteredProduct);

                  if (!muenzfachNode.variantImage) {
                    muenzfachNode.variantImage = matchedVariant.image?.url || null;
                    muenzfachNode.variantSku = matchedVariant.sku || null;
                    muenzfachNode.variantId = matchedVariant.id || null;
                    muenzfachNode.variantPrice = matchedVariant?.price?.amount || null;
                    muenzfachNode.compareAtPrice = matchedVariant?.compareAtPrice?.amount || null;
                    muenzfachNode.currencyCode = matchedVariant?.price?.currencyCode || 'EUR';
                    muenzfachNode.availableForSale = matchedVariant?.availableForSale || false;
                    muenzfachNode.currentlyNotInStock = matchedVariant?.currentlyNotInStock || false;
                  }
                }
              }
            });
          }
        });
      }
    });

    return tree;
  }

  // -------------------------------- Clear Container --------------------------------
  function clearContainer(container) {
    if (container) container.innerHTML = '';
  }

  // -------------------------------- Renderers (with hint + aria-disabled) --------------------------------
  function renderProduct(trackEl, title, frontdesignKey, products = []) {
    if (!trackEl || !products?.length) return;
    const sortedProducts = sortProductsByAvailability(products);
    const product = sortedProducts[0];
    const slug = slugify(title);

    const variantId = (product.variantId || '').replace('gid://shopify/ProductVariant/', '');
    const isSoldOut = !product.availableForSale || product.currentlyNotInStock;
    const soldOutClass = isSoldOut ? ' sold-out' : '';
    const priceDisplay = formatPrice(product.variantPrice, product.currencyCode);
    const compareAtPriceDisplay = product.compareAtPrice ? formatPrice(product.compareAtPrice, product.currencyCode) : '';
    const discountPercent = calculateDiscount(product.variantPrice, product.compareAtPrice);

    const slide = document.createElement('div');
    slide.className = 'swiper-slide';

    const wrapper = document.createElement('div');
    wrapper.className = 'slider__data ' + `${frontdesignKey.toLowerCase()}-${slug}`;
    wrapper.dataset.item = `${frontdesignKey.toLowerCase()}-${slug}`;
    wrapper.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');

    wrapper.innerHTML = `
      <div class="product-item${soldOutClass}">
        ${isSoldOut ? buildSoldOutHintHTML() : ''}
        <img src="${thumbnailUrl(product.imageUrl)}" alt="${product.imageAlt || ''}" 
             width="180" height="115"
             loading="eager"
             data-price="${product.variantPrice || ''}"  
             data-compare-price="${product.compareAtPrice || ''}"
             data-handle="${product.handle || ''}"  
             data-id="${variantId || ''}" 
             data-variantSku="${product.variantSku || ''}"
             data-available="${product.availableForSale}"
             data-in-stock="${!product.currentlyNotInStock}"/>
        <div class="product-info">
          <h3>${title}</h3>
          <div class="price-info">
            ${compareAtPriceDisplay ? `<span class="compare-price">${compareAtPriceDisplay}</span>` : ''}
            <span class="current-price">${priceDisplay}</span>
            ${discountPercent > 0 ? `<span class="discount">-${discountPercent}%</span>` : ''}
          </div>
          ${isSoldOut ? '<span class="sold-out-label">Ausverkauft</span>' : ''}
        </div>
      </div>
    `;
    slide.appendChild(wrapper);
    trackEl.appendChild(slide);
  }

  function renderLederart(trackEl, title, products = []) {
    if (!trackEl || !products?.length) return;
    const sortedProducts = sortProductsByAvailability(products);
    const product = sortedProducts[0];

    const variantId = (product.variantId || '').replace('gid://shopify/ProductVariant/', '');
    const isSoldOut = !product.availableForSale || product.currentlyNotInStock;
    const soldOutClass = isSoldOut ? ' sold-out' : '';
    const priceDisplay = formatPrice(product.variantPrice, product.currencyCode);
    const compareAtPriceDisplay = product.compareAtPrice ? formatPrice(product.compareAtPrice, product.currencyCode) : '';
    const discountPercent = calculateDiscount(product.variantPrice, product.compareAtPrice);

    const slide = document.createElement('div');
    slide.className = 'swiper-slide';

    const wrapper = document.createElement('div');
    wrapper.className = 'slider__data ' + title;
    wrapper.dataset.item = title;
    wrapper.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');

    wrapper.innerHTML = `
      <div class="product-item${soldOutClass}">
        ${isSoldOut ? buildSoldOutHintHTML() : ''}
        <img src="${thumbnailUrl(product.imageUrl)}" alt="${product.imageAlt || ''}" 
             width="180" height="115"
             loading="lazy"
             data-price="${product.variantPrice || ''}" 
             data-compare-price="${product.compareAtPrice || ''}"
             data-handle="${product.handle || ''}"  
             data-id="${variantId || ''}" 
             data-variantSku="${product.variantSku || ''}"
             data-available="${product.availableForSale}"
             data-in-stock="${!product.currentlyNotInStock}"/>
        <div class="product-info">
          <h3>${title}</h3>
          <div class="price-info">
            ${compareAtPriceDisplay ? `<span class="compare-price">${compareAtPriceDisplay}</span>` : ''}
            <span class="current-price">${priceDisplay}</span>
            ${discountPercent > 0 ? `<span class="discount">-${discountPercent}%</span>` : ''}
          </div>
          ${isSoldOut ? '<span class="sold-out-label">Ausverkauft</span>' : ''}
        </div>
      </div>
    `;
    slide.appendChild(wrapper);
    trackEl.appendChild(slide);
  }

  // Drop-in: renderFarbe with formatted <h3> like "Purist (Druckknopf)"
  // Keeps all existing behavior; only the title rendering is changed.

  (function () {
    function toTitleCase(str) {
      return String(str)
        .trim()
        .split(/\s+/)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    }

    // "purist-druckknopf" -> "Purist (Druckknopf)"
    // "gelb_genarbt"      -> "Gelb (Genarbt)"
    // "Purist (Druckknopf)" stays as-is
    function formatTitle(raw) {
      if (!raw) return '';
      const title = String(raw).trim();

      if (/\w+\s*\(.+\)/.test(title)) return title; // already "X (Y)"

      const normalized = title.replace(/[_\s]+/g, '-');
      const parts = normalized.split('-').filter(Boolean);

      if (parts.length <= 1) return toTitleCase(parts[0] || '');

      const main = toTitleCase(parts[0]);
      const rest = toTitleCase(parts.slice(1).join(' '));
      return `${main} (${rest})`;
    }

    // Assumes helpers exist: formatPrice, calculateDiscount, buildSoldOutHintHTML
    window.renderFarbe = function renderFarbe(trackEl, title, FarbItem) {
      if (!trackEl || !FarbItem) return;

      Object.entries(FarbItem?.Muenzfach || {}).forEach(([muenzfachKey, item]) => {
        const slug = slugify(title);
        const variantId = (item.variantId || '').replace('gid://shopify/ProductVariant/', '');
        const isSoldOut = !item.availableForSale || item.currentlyNotInStock;
        const soldOutClass = isSoldOut ? ' sold-out' : '';
        const priceDisplay = formatPrice(item.variantPrice, item.currencyCode);
        const compareAtPriceDisplay = item.compareAtPrice
          ? formatPrice(item.compareAtPrice, item.currencyCode)
          : '';
        const discountPercent = calculateDiscount(item.variantPrice, item.compareAtPrice);

        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        const wrapper = document.createElement('div');
        wrapper.dataset.item = slug || '';
        wrapper.dataset.muenzfach = slugify(muenzfachKey) || '';
        wrapper.className = 'slider__data ' + (slug || '');
        wrapper.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');

        wrapper.innerHTML = `
          <div class="product-item${soldOutClass}">
            ${isSoldOut ? buildSoldOutHintHTML() : ''}
            <img src="${thumbnailUrl(item.variantImage)}" alt=""
                width="180" height="115"
                loading="lazy"
                data-price="${item.variantPrice || ''}"
                data-compare-price="${item.compareAtPrice || ''}"
                data-id="${variantId || ''}"
                data-handle="${item.handle || ''}"
                data-variantSku="${item.variantSku || ''}"
                data-available="${item.availableForSale}"
                data-in-stock="${!item.currentlyNotInStock}" />
            <div class="product-info">
              <h3>${title}</h3>
              <div class="price-info">
                ${compareAtPriceDisplay ? `<span class="compare-price">${compareAtPriceDisplay}</span>` : ''}
                <span class="current-price">${priceDisplay}</span>
                ${discountPercent > 0 ? `<span class="discount">-${discountPercent}%</span>` : ''}
              </div>
              ${isSoldOut ? '<span class="sold-out-label">Ausverkauft</span>' : ''}
            </div>
          </div>
        `;

        slide.appendChild(wrapper);
        trackEl.appendChild(slide);
      })
    };
  })();

  function renderMuenzfach(trackEl, title, muenzfachItem) {
    if (!trackEl || !muenzfachItem) return;
    const slug = slugify(title);
    const variantId = (muenzfachItem.variantId || '').replace('gid://shopify/ProductVariant/', '');
    const isSoldOut = !muenzfachItem.availableForSale || muenzfachItem.currentlyNotInStock;
    const soldOutClass = isSoldOut ? ' sold-out' : '';
    const priceDisplay = formatPrice(muenzfachItem.variantPrice, muenzfachItem.currencyCode);
    const compareAtPriceDisplay = muenzfachItem.compareAtPrice ? formatPrice(muenzfachItem.compareAtPrice, muenzfachItem.currencyCode) : '';
    const discountPercent = calculateDiscount(muenzfachItem.variantPrice, muenzfachItem.compareAtPrice);

    const option = document.querySelector('#konfigurator-variants option.' + muenzfachItem.variantSku);

    let imageUrl = muenzfachItem.variantImage;

    if (option) {
      imageUrl = option.getAttribute('data-Bimage');
    }

    const slide = document.createElement('div');
    slide.className = 'swiper-slide';

    const wrapper = document.createElement('div');
    wrapper.dataset.item = slug;
    wrapper.className = 'slider__data ' + slug;
    wrapper.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');

    wrapper.innerHTML = `
      <div class="product-item${soldOutClass}">
        ${isSoldOut ? buildSoldOutHintHTML() : ''}
        <img src="${thumbnailUrl(imageUrl)}" alt="" 
             width="180" height="115"
             loading="lazy"
             data-price="${muenzfachItem.variantPrice || ''}" 
             data-compare-price="${muenzfachItem.compareAtPrice || ''}"
             data-id="${variantId || ''}" 
             data-handle="${muenzfachItem.handle || ''}" 
             data-variantSku="${muenzfachItem.variantSku || ''}"
             data-available="${muenzfachItem.availableForSale}"
             data-in-stock="${!muenzfachItem.currentlyNotInStock}" />
        <div class="product-info">
          <h3>${title}</h3>
          <div class="price-info">
            ${compareAtPriceDisplay ? `<span class="compare-price">${compareAtPriceDisplay}</span>` : ''}
            <span class="current-price">${priceDisplay}</span>
            ${discountPercent > 0 ? `<span class="discount">-${discountPercent}%</span>` : ''}
          </div>
          ${isSoldOut ? '<span class="sold-out-label">Ausverkauft</span>' : ''}
        </div>
      </div>
    `;
    slide.appendChild(wrapper);
    trackEl.appendChild(slide);
  }

  // -------------------------------- DOM Assembly --------------------------------
  async function updatemodel(data) {
    const modellContainer = document.querySelector('#modell .filter__data');
    const lederartContainer = document.querySelector('#lederart');
    const farbeContainer = document.querySelector('#farbe');
    const muenzfachContainer = document.querySelector('#muenzfach');

    const builtModell = makeSwiperContainer(`modell`);
    const { container: wrapperModell, track: trackModell } = builtModell;

    clearContainer(modellContainer);
    clearContainer(lederartContainer);
    clearContainer(farbeContainer);
    clearContainer(muenzfachContainer);

    Object.entries(data || {}).forEach(([frontdesignKey, frontdesignItem]) => {
      const verschlussItems = frontdesignItem?.Verschlusssystem || {};

      Object.entries(verschlussItems).forEach(([verschlussKey, verschlussData]) => {
        const modeltitle = slugify(verschlussKey);

        if (modellContainer) renderProduct(trackModell, verschlussKey, frontdesignKey, verschlussData._products);

        const builtLeder = makeSwiperContainer(`lederart ${frontdesignKey.toLowerCase()}-${modeltitle}`);
        const { container: wrapperLeder, track: trackLeder } = builtLeder;
        let hasAnyLeder = false;

        const builtFarbe = makeSwiperContainer(`farbe ${frontdesignKey.toLowerCase()}-${modeltitle}`);
        const { container: wrapperFarbe, track: trackFarbe } = builtFarbe;
        let hasFarbe = true;

        Object.entries(verschlussData.Lederart || {}).forEach(([lederartKey, lederart]) => {
          const lederartslug = slugify(lederartKey);
          renderLederart(trackLeder, lederartslug, lederart._products);
          hasAnyLeder = true;

          Object.entries(lederart.options?.Farbe || {}).forEach(([FarbeKey, FarbItem]) => {
            if (FarbItem?.variantId) {
              const farbeTitle = slugify(FarbeKey);
              renderFarbe(trackFarbe, FarbeKey, FarbItem);

              const builtM = makeSwiperContainer(`muenzfach ${frontdesignKey.toLowerCase()}-${modeltitle} ${lederartslug} ${farbeTitle}`);
              const { container: wrapperMuenzfach, track: trackMuenzfach } = builtM;
              let hasMuenzfach = false;

              Object.entries(FarbItem?.Muenzfach || {})
                .sort(([a], [b]) => {
                  const base = (k) => k.split(/[- ]/)[0].trim();
                  return order.indexOf(base(a)) - order.indexOf(base(b));
                })
                .forEach(([muenzfachKey, muenzfachItem]) => {
                  if (muenzfachItem?.variantId) {
                    const muenzfachTitle = slugify(muenzfachKey);
                    renderMuenzfach(trackMuenzfach, muenzfachKey, muenzfachItem);
                    hasMuenzfach = true;
                  }
                });

              if (hasMuenzfach && muenzfachContainer) {
                muenzfachContainer.appendChild(wrapperMuenzfach);
              }
            }
          });
        });

        modellContainer.appendChild(wrapperModell);

        if (hasFarbe && farbeContainer) {
          farbeContainer.appendChild(wrapperFarbe);
        }

        if (hasAnyLeder && lederartContainer) {
          lederartContainer.appendChild(wrapperLeder);
        }
      });
    });

    // Enforce sold-out last before and after swiper init (covers hidden/visible panes)
    reorderSoldOutToEnd();
    initSwipers();
    reorderSoldOutToEnd();

    setTimeout(() => {
      const visiblePane =
        document.querySelector('.product-thumbnails .tabcontent[style*="display: block"]') ||
        document.querySelector('.product-thumbnails .tabcontent:not([style])');
      reorderSoldOutToEnd(visiblePane || document);
      refreshVisibleSwipers(visiblePane || document);
    }, 0);
  }

  // [OPT-E] loadImage: preload then swap src — with cancellation token to prevent stale callbacks
  // Each call stamps mainImg with a token; the onload only applies if it's still the latest.
  function loadImage(targetElement, url) {
    if (!targetElement || !url) return;
    // Increment token — any earlier pending load for this element is now cancelled
    const token = (targetElement._loadToken = (targetElement._loadToken || 0) + 1);
    const img = new Image();
    img.onload = () => {
      if (targetElement._loadToken !== token) return; // superseded by a newer call
      targetElement.setAttribute('src', url);
    };
    img.onerror = () => { console.warn('Image failed to load:', url); };
    img.src = url;
  }

  // Preload ALL front + back images from the variant select into the browser cache.
  // Runs in the background after boot — makes subsequent color-switches near-instant.
  function preloadAllVariantImages() {
    const options = document.querySelectorAll('#konfigurator-variants option');
    options.forEach((opt) => {
      const fUrl = opt.getAttribute('data-Fimage');
      const bUrl = opt.getAttribute('data-Bimage');
      if (fUrl) { const i = new Image(); i.src = fUrl; }
      if (bUrl) { const i = new Image(); i.src = bUrl; }
    });
  }

  // -------------------------------- Backwards default selection logic --------------------------------
  function applyBackwardsDefaults(changedLevel /* "modell" | "lederart" */) {
    // Find active model
    const activeModelTile = document.querySelector('#modell .filter__data.modell .slider__data.active') ||
      document.querySelector('#modell .filter__data.modell .slider__data');
    const modelKey = activeModelTile ? '.' + activeModelTile.dataset.item : '';

    // Activate correct Lederart container for the model
    const lederartContainers = document.querySelectorAll('.lederart.filter__data');
    lederartContainers.forEach((c) => c.classList.remove('active'));
    if (modelKey) document.querySelectorAll('.lederart.filter__data' + modelKey).forEach((c) => c.classList.add('active'));

    // If model changed, also reset Lederart selection to first available
    if (changedLevel === 'modell') {
      const activeLederContainer = document.querySelector('.lederart.filter__data.active');
      clickFirstAvailable(activeLederContainer);
    }

    // Lederart -> Farbe
    const activeLederTile = document.querySelector('.lederart.filter__data.active .slider__data.active') ||
      document.querySelector('.lederart.filter__data.active .slider__data');
    const lederKey = activeLederTile ? '.' + activeLederTile.dataset.item : '';

    const farbeContainers = document.querySelectorAll('.farbe.filter__data');
    farbeContainers.forEach((c) => c.classList.remove('active'));

    if (modelKey) {
      document.querySelectorAll('.farbe.filter__data' + modelKey).forEach((c) => c.classList.add('active'));
    }

    // Always reset Farbe to first available after model/lederart changes
    const activeFarbeContainer = document.querySelector('.farbe.filter__data.active');
    clickFirstAvailable(activeFarbeContainer);

    // Resolve Farbe -> Münzfach
    const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
    const colorKey = activeColorTile ? '.' + activeColorTile.dataset.item : '';
    const muenzContainers = document.querySelectorAll('.muenzfach.filter__data');
    muenzContainers.forEach((c) => c.classList.remove('active'));
    if (modelKey && colorKey) {
      document.querySelectorAll('.muenzfach.filter__data' + modelKey + colorKey).forEach((c) => c.classList.add('active'));
    }

    // Keep sold-outs at end after the reset
    reorderSoldOutToEnd();
  }

  // Copy ALL relevant attributes from source <img> to target <img>.
  // During initial load (_loaderVisible=true) the overlay covers the screen, so we set
  // src directly — no async preload needed, and waitForInitialImages sees the final src.
  // After the loader hides, uses CSS crossfade so swaps feel smooth.
  function syncImgAttributes(targetImg, sourceImg) {
    if (!targetImg || !sourceImg) return;

    const newSrc = sourceImg.getAttribute('src');

    // Apply non-src attributes immediately (no reflow risk)
    Array.from(targetImg.attributes).forEach(attr => {
      if (attr.name.startsWith('data-')) targetImg.removeAttribute(attr.name);
    });
    Array.from(sourceImg.attributes).forEach(attr => {
      const name = attr.name;
      if (name === 'alt' || name === 'srcset' || name === 'sizes' || name.startsWith('data-')) {
        targetImg.setAttribute(name, attr.value);
      }
    });

    if (!newSrc || targetImg.getAttribute('src') === newSrc) return;

    // ── Init path: loader is visible, set src directly so waitForInitialImages
    //    sees the real URL and waits for the actual image pixels ──────────────
    if (_loaderVisible) {
      targetImg.setAttribute('src', newSrc);
      return;
    }

    // ── Interactive path: crossfade via CSS class ─────────────────────────────
    // Stamp for last-write-wins: rapid clicks cancel previous pending loads
    targetImg.dataset._pendingSrc = newSrc;

    const preloader = new Image();
    preloader.onload = () => {
      if (targetImg.dataset._pendingSrc !== newSrc) return; // superseded
      delete targetImg.dataset._pendingSrc;
      targetImg.classList.add('bd-img-swapping');
      requestAnimationFrame(() => {
        targetImg.setAttribute('src', newSrc);
        targetImg.classList.remove('bd-img-swapping');
      });
    };
    preloader.onerror = () => {
      if (targetImg.dataset._pendingSrc === newSrc) {
        delete targetImg.dataset._pendingSrc;
        targetImg.setAttribute('src', newSrc);
      }
    };
    preloader.src = newSrc;
  }

  // -------------------------------- Model Availability (context-aware) --------------------------------
  // Dynamically marks model tiles as sold-out when the selected color + muenzfach
  // combination is not available for that model. Mirrors how color tiles show availability.
  function updateModellAvailability() {
    const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
    const colorKey = activeColorTile ? activeColorTile.dataset.item : '';

    const modelTiles = document.querySelectorAll('#modell .filter__data.modell .slider__data');

    modelTiles.forEach((tile) => {
      const modelKey = tile.dataset.item;
      if (!modelKey) return;

      const productItem = tile.querySelector('.product-item');
      if (!productItem) return;

      // Store original global sold-out state once (set at render time by renderProduct)
      if (tile.dataset.originalSoldOut === undefined) {
        tile.dataset.originalSoldOut = productItem.classList.contains('sold-out') ? 'true' : 'false';
      }
      const globallyUnavailable = tile.dataset.originalSoldOut === 'true';

      // A model is only contextually unavailable if this color doesn't exist for it at all.
      // Münzfach is never a reason to mark a model unavailable — the selection auto-adjusts.
      let contextuallyAvailable = true;
      if (colorKey) {
        const muenzContainers = document.querySelectorAll(
          `.muenzfach.filter__data.${modelKey}.${colorKey}`
        );
        if (muenzContainers.length === 0) {
          contextuallyAvailable = false;
        } else {
          // Available if at least one non-sold-out muenzfach tile exists for this model+color
          contextuallyAvailable = false;
          muenzContainers.forEach((container) => {
            if (contextuallyAvailable) return;
            if (container.querySelector('.product-item:not(.sold-out)')) {
              contextuallyAvailable = true;
            }
          });
        }
      }

      const isUnavailable = globallyUnavailable || !contextuallyAvailable;

      if (isUnavailable) {
        productItem.classList.add('sold-out');
        tile.setAttribute('aria-disabled', 'true');
        if (!productItem.querySelector('.sold-out-label')) {
          const label = document.createElement('span');
          label.className = 'sold-out-label';
          label.textContent = 'Ausverkauft';
          productItem.appendChild(label);
        }
      } else {
        productItem.classList.remove('sold-out');
        tile.setAttribute('aria-disabled', 'false');
        productItem.querySelector('.sold-out-label')?.remove();
      }
    });

    const modellPane = document.getElementById('modell');
    if (modellPane) reorderSoldOutToEnd(modellPane);
  }

  // -------------------------------- Page Init / Buttons --------------------------------
  function wireButtons() {
    let showingFront = true;
    const vid = document.querySelector('.product-video');

    const backBtn = document.getElementById('backplace');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        const img = document.querySelector('.main-product-img');
        if (img) showAndHideSiblings(img);
        if (vid) vid.pause();
      });
    }


    /* ===== Code-os starts ===== */
    let activeImageSide = 'frontSide';
    let hasFlippedOnMuenzfach = false;
    let scheduledCheckId = null;

    /* ===== selectors (single source of truth) ===== */
    const MAIN_SEL = '.main-product-img';
    const FRONT_SEL = '.main-product-F-img';
    const BACK_SEL = '.main-produc-B-img';
    // const BACK_FRONT_BTN = '#vorderseiteBtn font';
    const BACK_FRONT_BTN = '#vorderseiteBtn';
    const TABS_CONTAINER = '.product-options.tab';
    const TAB_BTNS_SEL = '.product-options.tab button';
    const NEXT_BTN_SEL = '.Konfigurator_next_btn';

    // ★ FIX: guard prevents re-entrant execution when resetToDefaultMuenzfach fires .click() programmatically
    let _thumbnailClickActive = false;

    // Remembers the last münzfach the user explicitly selected.
    // Used to restore selection when switching model/color, even if the new
    // container has never had an active tile yet.
    let _lastSelectedMuenzfach = '';

    // -------------------------------- Click Handling / State Sync --------------------------------
    // 1) Product-thumbnails area
    document.addEventListener('click', function (e) {
      const clicked = e.target.closest('.product-thumbnails .filter__data .slider__data');
      if (!clicked) return;

      // ❗ Prevent selecting sold-out tiles
      if (isSoldOutTile(clicked)) {
        e.preventDefault();
        e.stopPropagation();
        const container = clicked.closest('.filter__data');
        clickFirstAvailable(container);
        return;
      }

      // Re-entrancy guard: if we're already inside this handler (e.g. resetToDefaultMuenzfach called .click()),
      // only do the minimal active-state + variant-id update, then exit.
      if (_thumbnailClickActive) {
        // Still mark the tile active and update the form id
        const parent = clicked.parentElement;
        const grandParent = parent.parentElement;
        if (grandParent) {
          Array.from(grandParent.children).forEach((sibling) => {
            sibling.querySelector('.slider__data')?.classList.remove('active');
          });
        }
        clicked.classList.add('active');
        const img2 = clicked.querySelector('img');
        if (img2) {
          const opt2 = document.querySelector('#konfigurator-variants option.' + img2.dataset.variantsku);
          if (opt2) {
            const addFormId = document.querySelector('.action__btn form [name="id"]');
            const pid = img2.dataset.id;
            if (addFormId && pid) addFormId.value = pid;
          }
        }
        return;
      }

      _thumbnailClickActive = true;
      try {
      const parent = clicked.parentElement;
      const grandParent = parent.parentElement;
      if (grandParent) {
        Array.from(grandParent.children).forEach((sibling) => {
          sibling.querySelector(".slider__data").classList.remove('active')
        })
      };
      clicked.classList.add('active');

      const img = clicked.querySelector('img');
      if (!img) return;

      const handle = img.dataset.handle;
      const productid = img.dataset.id;
      const variantsku = img.dataset.variantsku;
      const price = img.dataset.price;

      const option = document.querySelector('#konfigurator-variants option.' + variantsku);

      const frontImg = document.querySelector('.main-product-F-img');
      const backImg = document.querySelector('.main-produc-B-img');
      const VideoTag = document.querySelector('.product-video');

      if (option) {
        const videoUrl = option.value;
        const frontImageUrl = option.getAttribute('data-Fimage');
        const backImageUrl = option.getAttribute('data-Bimage');

        loadImage(frontImg, frontImageUrl);
        loadImage(backImg, backImageUrl);

        if (VideoTag && videoUrl) {
          VideoTag.setAttribute('src', videoUrl);
          // Mobile Chrome requires an explicit load() after changing src,
          // otherwise the video element stays stuck on the previous source.
          try { VideoTag.load(); } catch (_) {}
        }

        const pdpBtn = document.querySelector('.pdp__btn');
        if (pdpBtn && handle && productid) pdpBtn.setAttribute('href', '/products/' + handle + '?variant=' + productid);

        const addFormId = document.querySelector('.action__btn form [name="id"]');
        if (addFormId && productid) addFormId.value = productid;


        const mainImg = document.querySelector('.main-product-img');
        if (activeImageSide === 'frontSide') {
          if (mainImg && frontImageUrl) {
            loadImage(mainImg, frontImageUrl);
          }
        } else {
          if (mainImg && backImageUrl) {
            loadImage(mainImg, backImageUrl);
          }
        }

        const priceElement = document.querySelector('.cls-unit-price');
        if (priceElement) priceElement.textContent = formatPrice(price, 'EUR');

        // Legacy active syncing across containers
        const modellItem = document.querySelector('.filter__data.modell .slider__data.active');
        const modellClass = modellItem ? '.' + modellItem.dataset.item : '';
        document.querySelectorAll('.filter__data.modell .slider__data').forEach((el) => el.classList.remove('active'));
        if (modellClass) {
          const modellActive = document.querySelector('.filter__data.modell .slider__data' + modellClass);
          if (modellActive) modellActive.classList.add('active');
        }

        const lederartItem = document.querySelector('.lederart.filter__data .slider__data.active');
        const lederartClass = lederartItem ? '.' + lederartItem.dataset.item : '';
        document.querySelectorAll('.lederart.filter__data.active .slider__data.active').forEach((el) => el.classList.remove('active'));
        document.querySelectorAll('.lederart.filter__data.active').forEach((el) => el.classList.remove('active'));
        document.querySelectorAll('.lederart.filter__data' + modellClass).forEach((el) => el.classList.add('active'));
        if (lederartClass) {
          const lederartActive = document.querySelector('.lederart.filter__data.active .slider__data' + lederartClass);
          if (lederartActive) lederartActive.classList.add('active');
        }

        const farbeItem = document.querySelector('.farbe.filter__data .slider__data.active');
        const farbeClass = farbeItem ? '.' + farbeItem.dataset.item : '';
        const muenzfachKey = farbeItem ? farbeItem.dataset.muenzfach : '';
        document.querySelectorAll('.farbe.filter__data.active .slider__data.active').forEach((el) => el.classList.remove('active'));
        document.querySelectorAll('.farbe.filter__data.active').forEach((el) => el.classList.remove('active'));
        if (modellClass) {
          document.querySelectorAll('.farbe.filter__data' + modellClass).forEach((c) => c.classList.add('active'));
        }
        document.querySelectorAll('.farbe.filter__data' + modellClass + lederartClass).forEach((el) => el.classList.add('active'));
        if (farbeClass) {
          const farbeActive = document.querySelector('.farbe.filter__data.active .slider__data' + farbeClass);
          if (farbeActive) farbeActive.classList.add('active');
        }

        // Helper: apply a muenzfach filter key to active farbe containers and return
        // whether at least one visible (non-removed) tile exists after filtering.
        function applyMuenzfachFilter(filterKey) {
          let hasVisibleTile = false;
          document.querySelectorAll('.farbe.filter__data.active').forEach((el) => {
            el.querySelectorAll('.swiper-slide').forEach((c) => {
              c.classList.remove('remove');
              if (c.querySelector(`.slider__data:not([data-muenzfach="${filterKey}"])`)) {
                c.classList.add('remove');
              } else {
                hasVisibleTile = true;
              }
              if (
                c.querySelector(`.slider__data[data-muenzfach="${filterKey}"]`) &&
                c.querySelector(`img[data-variantsku="${variantsku}"]`)
              ) {
                c.querySelector('.slider__data').click();
                updateModellImageFromSource();
              }
            });
          });
          return hasVisibleTile;
        }

        // Helper: sync muenzfach .active containers to the currently active model + color
        function syncMuenzfachActiveContainers() {
          const newModellItem = document.querySelector('.filter__data.modell .slider__data.active');
          const newModellClass = newModellItem ? '.' + newModellItem.dataset.item : '';
          const newFarbeItem  = document.querySelector('.farbe.filter__data.active .slider__data.active');
          const newColorClass  = newFarbeItem  ? '.' + newFarbeItem.dataset.item  : '';
          document.querySelectorAll('.muenzfach.filter__data').forEach((c) => c.classList.remove('active'));
          if (newModellClass && newColorClass) {
            document.querySelectorAll('.muenzfach.filter__data' + newModellClass + newColorClass)
              .forEach((c) => c.classList.add('active'));
          }
        }

        // Helper: reset muenzfach to the default (first available tile after pageload)
        // and remove all farbe color filters so all colors are shown again.
        function resetToDefaultMuenzfach() {
          syncMuenzfachActiveContainers();

          // Clear the remembered choice — user's selection is no longer valid
          _lastSelectedMuenzfach = '';

          document.querySelectorAll('.farbe.filter__data.active .swiper-slide').forEach((c) => {
            c.classList.remove('remove');
          });

          const defaultMuenzfachTile = document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:not(.remove):first-child .slider__data'
          ) || document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:first-child .slider__data'
          );
          if (defaultMuenzfachTile) {
            defaultMuenzfachTile.click();
          }
          updateModellImageFromSource();
        }

        // ── Switch münzfach container to match the new model + color ────────────
        syncMuenzfachActiveContainers();

        // ── Restore or reset münzfach selection ──────────────────────────────────
        // Use _lastSelectedMuenzfach (the last thing the user explicitly clicked),
        // NOT the active tile in the container — new containers start empty.
        const wantedKey = _lastSelectedMuenzfach;

        if (wantedKey) {
          // Does this key exist as a tile in the new container?
          const tileForKey = document.querySelector(
            `.muenzfach.filter__data.active .slider__data.${wantedKey}`
          );

          if (tileForKey && !isSoldOutTile(tileForKey)) {
            // ✓ Wanted münzfach exists and is available — restore it
            document.querySelectorAll('.muenzfach.filter__data.active .slider__data')
              .forEach((t) => t.classList.remove('active'));
            tileForKey.classList.add('active');
          } else {
            // ✗ Doesn't exist (e.g. XXL not available for Gummiband) → default
            resetToDefaultMuenzfach();
          }
        } else {
          // No explicit choice yet — click the first available tile
          const firstTile = document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:not(.remove):first-child .slider__data'
          ) || document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:first-child .slider__data'
          );
          if (firstTile) firstTile.click();
        }

        // Update farbe color filter to match active münzfach
        if (muenzfachKey) {
          const hasVisible = applyMuenzfachFilter(muenzfachKey);
          if (!hasVisible) resetToDefaultMuenzfach();
        }

        updateModellImageFromSource();
        updateModellAvailability();
        // const inModell = !!clicked.closest('#modell');
        // const inLederart = !!clicked.closest('#lederart');
        // if (inModell) applyBackwardsDefaults('modell');
        // else if (inLederart) applyBackwardsDefaults('lederart');

        reorderSoldOutToEnd();
      }
      } finally {
        _thumbnailClickActive = false;
      }
    });

    // 2) Generic slider click handler
    document.addEventListener('click', function (e) {
      const clicked = e.target.closest('.slider__data');
      if (!clicked) return;

      // Prevent selecting sold-out anywhere
      if (isSoldOutTile(clicked)) {
        e.preventDefault();
        e.stopPropagation();
        const container = clicked.closest('.filter__data');
        clickFirstAvailable(container);
        return;
      }

      const container = clicked.closest('.filter__data');
      const wrap = clicked.closest('.swiper-wrapper');
      if (container) container.querySelectorAll('.slider__data').forEach((el) => el.classList.remove('active'));
      if (wrap) wrap.querySelectorAll('.slider__data').forEach((el) => el.classList.remove('active'));
      clicked.classList.add('active');

      // Remember the last münzfach the user explicitly chose
      if (container && container.classList.contains('muenzfach')) {
        _lastSelectedMuenzfach = clicked.dataset.item || '';
      }

      const img = clicked.querySelector('img');
      if (img) {
        const compareAtPrice = img.dataset.comparePrice;
        const oldPriceEl = document.querySelector('.old-price');
        if (oldPriceEl) {
          oldPriceEl.textContent = compareAtPrice ? `€${compareAtPrice}` : '';
          oldPriceEl.classList.add(`hide_${compareAtPrice}`);
        }
      }
    });

    

    /* ===== your existing toggle (fixed typo) ===== */
    const handleFrontBackToggleClick = (mainImage, frontImage, backImage, btn, activeTab) => {
      const mainImg = document.querySelector(mainImage);
      const frontImg = document.querySelector(frontImage);
      const backImg = document.querySelector(backImage);
      const backFrontBtn = document.querySelector(btn);
      const backText = backFrontBtn?.querySelector('.bd-back-os');
      const frontText = backFrontBtn?.querySelector('.bd-front-os');
      const videoElement = document.querySelector('.product-video');

      // --- Old code starts ---
      // if (activeTab === 'muenzfach') {
      //   const srcBackImg = backImg?.getAttribute('src');
      //   if (mainImg && srcBackImg) mainImg.setAttribute('src', srcBackImg);
      //   if (backFrontBtn) backFrontBtn.innerHTML = "Vorderseite";
      //   activeImageSide = "backSide";
      // } else if (activeTab === 'frontImage') {
      //   const srcFrontImg = frontImg?.getAttribute('src');
      //   if (mainImg && srcFrontImg) mainImg.setAttribute('src', srcFrontImg);
      //   if (backFrontBtn) backFrontBtn.innerHTML = "Rückseite";
      //   activeImageSide = "frontSide";
      // } else {
      //   const srcMainImg = mainImg?.getAttribute('src');
      //   if (mainImg && srcMainImg) mainImg.setAttribute('src', srcMainImg);
      //   if (backFrontBtn) backFrontBtn.innerHTML = "Rückseite";
      //   activeImageSide = "frontSide";
      // }
      // --- Old code Ends ---

      if (videoElement) videoElement.style.display = 'none';
      if (mainImg) {
        mainImg.style.display = 'block';
        // Cancel any in-flight loadImage() for mainImg — prevents a stale front-image
        // callback from overwriting the back-image after the user flips to Münzfach.
        mainImg._loadToken = (mainImg._loadToken || 0) + 1;
      }

      // --- New code starts ---
      if (activeTab === 'muenzfach') {
        // Read the back-image URL directly from the active variant's <option>,
        // NOT from the .main-produc-B-img element — that element is updated via
        // async loadImage() and may still have the previous color's src on
        // mobile Chrome where the network callback hasn't fired yet.
        const activeFarbeTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
        const activeSku = activeFarbeTile?.querySelector('img')?.dataset?.variantsku;
        const activeOption = activeSku
          ? document.querySelector(`#konfigurator-variants option.${activeSku}`)
          : null;
        const backUrlFromOption = activeOption?.getAttribute('data-Bimage');

        if (backUrlFromOption) {
          loadImage(mainImg, backUrlFromOption);
        } else if (backImg) {
          // Fallback to element src if option lookup fails
          syncImgAttributes(mainImg, backImg);
        }

        if (backFrontBtn) backFrontBtn.innerHTML = "Vorderseite";
        activeImageSide = "backSide";
        // Show FRONT text, hide BACK text (guarded)
        if (backText) backText.style.display = 'none';
        if (frontText) frontText.style.display = 'inline-block';
        if (videoElement) videoElement.style.display = 'none';

        // Find active model
        const activeModelTile = document.querySelector('#modell .filter__data.modell .slider__data.active') ||
          document.querySelector('#modell .filter__data.modell .slider__data');
        const modelKey = activeModelTile ? '.' + activeModelTile.dataset.item : '';

        // Find active farbe
        const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
        const colorKey = activeColorTile ? '.' + activeColorTile.dataset.item : '';

        // Find active muenzfach
        const activeMuenzfachTile = document.querySelector('.muenzfach.filter__data .slider__data.active');
        const muenzfachKey = activeMuenzfachTile ? '.' + activeMuenzfachTile.dataset.item : '';

        if (!muenzfachKey) {
          const elem = document.querySelector("div#muenzfach .filter__data" + modelKey + colorKey + ".active .swiper-slide:first-child .slider__data ");
          if (elem) elem.click();
        } else {
          document.querySelectorAll('.muenzfach.filter__data .slider__data').forEach((el) => {
            el.classList.remove('active');
          });

          let found = false;
          document.querySelectorAll('.muenzfach.filter__data' + modelKey + colorKey).forEach((c) => {
            c.querySelectorAll('.slider__data' + muenzfachKey).forEach((el) => {
              el.click();
              found = true;
            })
          });
          if (!found) {
            const elem = document.querySelector("div#muenzfach .filter__data" + modelKey + colorKey + ".active .swiper-slide:first-child .slider__data ");
            if (elem) elem.click();
          }
        }

      } else if (activeTab === 'frontImage') {
        // Same pattern: read front URL directly from option, not from the element
        const activeFarbeTileF = document.querySelector('.farbe.filter__data.active .slider__data.active');
        const activeSkuF = activeFarbeTileF?.querySelector('img')?.dataset?.variantsku;
        const activeOptionF = activeSkuF
          ? document.querySelector(`#konfigurator-variants option.${activeSkuF}`)
          : null;
        const frontUrlFromOption = activeOptionF?.getAttribute('data-Fimage');

        if (frontUrlFromOption) {
          loadImage(mainImg, frontUrlFromOption);
        } else if (frontImg) {
          syncImgAttributes(mainImg, frontImg);
        }

        if (backFrontBtn) backFrontBtn.innerHTML = "Rückseite";
        activeImageSide = "frontSide";
        if (backText) backText.style.display = 'inline-block';
        if (frontText) frontText.style.display = 'none';
        if (videoElement) videoElement.style.display = 'none';

      } else {
        // Fallback: mirror whatever the main image currently has onto thumbnails
        if (frontImg) {
          syncImgAttributes(mainImg, frontImg);
        }
        if (backFrontBtn) backFrontBtn.innerHTML = "Rückseite";
        activeImageSide = "frontSide";

        // Default: show BACK, hide FRONT (guarded)
        if (backText) backText.style.display = 'inline-block';
        if (frontText) frontText.style.display = 'none';
        if (videoElement) videoElement.style.display = 'none';
      }
      // --- New code Ends ---
    };

    /* ===== helper: read currently active tab's tab_data ===== */
    function getActiveTabData() {
      const activeBtn = document.querySelector(`${TABS_CONTAINER} button.active`);
      return activeBtn ? activeBtn.getAttribute('tab_data') : null;
    }

    /* ===== core: run once when muenzfach first becomes active ===== */
    function checkActiveTabAndMaybeFlipOnce() {
      const tabData = getActiveTabData();
      handleFrontBackToggleClick(MAIN_SEL, FRONT_SEL, BACK_SEL, BACK_FRONT_BTN, tabData);
    }

    /* ===== vorder button (unchanged) ===== */
    const vorderBtn = document.getElementById('vorderseiteBtn');
    if (vorderBtn) {
      vorderBtn.addEventListener('click', function () {
        if (activeImageSide === 'frontSide') {
          handleFrontBackToggleClick(MAIN_SEL, FRONT_SEL, BACK_SEL, BACK_FRONT_BTN, 'muenzfach');
        } else {
          handleFrontBackToggleClick(MAIN_SEL, FRONT_SEL, BACK_SEL, BACK_FRONT_BTN, 'frontImage');
        }
      });
    }

    /* ===== tabs & next wired in sync (no duplicate logic) ===== */
    document.querySelectorAll(TAB_BTNS_SEL).forEach((btn) => {
      btn.addEventListener('click', () => {
        checkActiveTabAndMaybeFlipOnce();
      });
    });

    const paginationNextBtn = document.querySelector(NEXT_BTN_SEL);
    if (paginationNextBtn) {
      paginationNextBtn.addEventListener('click', () => {
        checkActiveTabAndMaybeFlipOnce();
      });
    }


    // [OPT-B] Reduced from 6000ms: observer is safe to start right after boot settles
    setTimeout(initObserver, 300);

    let scheduled = false;
    let lastSrc = null;

    function scheduleActiveRead() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        handleActiveImageChange();
      });
    }

    function initObserver() {
      const farbeContainer = document.querySelector("#farbe");
      if (!farbeContainer) {
        console.warn("No #farbe container found.");
        return;
      }

      // Delegated click: just schedule a read (don't read immediately)
      farbeContainer.addEventListener("click", (e) => {
        if (!e.target.closest(".slider__data")) return;
        scheduleActiveRead();
      });

      // Observe .slider__data class changes; schedule a single read per frame
      const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (
            m.type === "attributes" &&
            m.attributeName === "class" &&
            m.target instanceof Element &&
            m.target.matches(".slider__data")
          ) {
            // Whether active was added or removed, just schedule one read
            scheduleActiveRead();
            break;
          }
        }
      });

      observer.observe(farbeContainer, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      // Initial read
      scheduleActiveRead();
    }

    // // --- Read & log the active image URL (with duplicate suppression) -----------
    // function handleActiveImageChange() {
    //   const activeElement = document.querySelector("#farbe .slider__data.active");
    //   if (!activeElement) return;

    //   const imgElement = activeElement.querySelector("img");
    //   if (!imgElement) return;

    //   const imgSrc = imgElement.getAttribute("src");
    //   if (!imgSrc || imgSrc === lastSrc) return; // prevent duplicate logs

    //   lastSrc = imgSrc;
    //   if (lastSrc) {
    //     updateModellImage(lastSrc);
    //   }
    // }

    // // --- Update the targeted element inside #modell -----------------------------
    // function updateModellImage(src) {
    //   if (!src) return;

    //   const modellImg = document.querySelector(
    //     '#modell .slider__data.active img'
    //   );

    //   if (!modellImg) {
    //     return;
    //   }

    //   // Update only if different to avoid unnecessary work
    //   if (modellImg.getAttribute("src") !== src) {
    //     modellImg.setAttribute("src", src);
    //   }
    // }

    function handleActiveImageChange() {
      const activeElement = document.querySelector("#farbe .slider__data.active");
      if (!activeElement) return;

      const imgElement = activeElement.querySelector("img");
      if (!imgElement) return;

      // Use variantsku for dedup — src alone can miss re-selections of same color
      const sku = imgElement.getAttribute("data-variantsku") || '';
      if (!sku || sku === lastSrc) return;

      lastSrc = sku;

      // Copy ALL attributes from the source image to the target image in #modell
      updateModellImageFromSource();
      // Switch active münzfach container to match the new model+color
      updateMuenzfach();

      // Restore last selected münzfach in the new container, or fall back to default
      if (_lastSelectedMuenzfach) {
        const tileForKey = document.querySelector(
          `.muenzfach.filter__data.active .slider__data.${_lastSelectedMuenzfach}`
        );
        if (tileForKey && !isSoldOutTile(tileForKey)) {
          document.querySelectorAll('.muenzfach.filter__data.active .slider__data')
            .forEach((t) => t.classList.remove('active'));
          tileForKey.classList.add('active');
        } else {
          // Wanted münzfach doesn't exist for new model+color → reset to default
          const firstTile = document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:not(.remove):first-child .slider__data'
          ) || document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:first-child .slider__data'
          );
          if (firstTile) firstTile.click();
        }
      } else {
        const activeMuenzAfterSwitch = document.querySelector('.muenzfach.filter__data.active .slider__data.active');
        if (!activeMuenzAfterSwitch) {
          const firstTile = document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:not(.remove):first-child .slider__data'
          ) || document.querySelector(
            'div#muenzfach .filter__data.active .swiper-slide:first-child .slider__data'
          );
          if (firstTile) firstTile.click();
        }
      }
      updateModellAvailability();
    }

    // --- Update the targeted element inside #modell ------------------------------
    // Uses a 3-tier fallback so every model tile always shows the selected colour:
    //   1. exact color + muenzfach match
    //   2. same color, any muenzfach
    //   3. first available tile in that model's farbe container
    function updateModellImageFromSource() {
      const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
      const colorKey = activeColorTile ? '.' + activeColorTile.dataset.item : '';
      const activeMuenzfachTile = document.querySelector('.muenzfach.filter__data .slider__data.active');
      const muenzfachKey = activeMuenzfachTile ? activeMuenzfachTile.dataset.item : '';

      const modelTiles = document.querySelectorAll('#modell .filter__data.modell .slider__data');
      const modelKeyList = [];
      modelTiles.forEach((el) => { if (el.dataset.item) modelKeyList.push(el.dataset.item); });

      const modelImageList = {};

      modelKeyList.forEach((modelKey) => {
        document.querySelectorAll('.farbe.filter__data.' + modelKey).forEach((el) => {
          // Already found for this model? skip
          if (modelImageList[modelKey]) return;

          // Tier 1: exact color + muenzfach
          if (colorKey && muenzfachKey) {
            const exact = el.querySelector(`${colorKey}[data-muenzfach="${muenzfachKey}"] img`);
            if (exact) { modelImageList[modelKey] = exact; return; }
          }

          // Tier 2: same color, any muenzfach
          if (colorKey) {
            const sameColor = el.querySelector(`${colorKey} img`);
            if (sameColor) { modelImageList[modelKey] = sameColor; return; }
          }

          // Tier 3: first visible tile
          const first = el.querySelector('.swiper-slide:not(.remove) .slider__data img');
          if (first) { modelImageList[modelKey] = first; }
        });
      });

      modelTiles.forEach((el) => {
        const modelKey = el.dataset.item;
        if (modelImageList.hasOwnProperty(modelKey)) {
          const targetImg = el.querySelector('img');
          const sourceImg = modelImageList[modelKey];
          if (targetImg && sourceImg && targetImg.getAttribute("src") !== sourceImg.getAttribute("src")) {
            syncImgAttributes(targetImg, sourceImg);
          }
        }
      });
    }

    // --- Update the targeted element inside .muenzfach ------------------------------
    function updateMuenzfach() {
      // Find active model
      const activeModelTile = document.querySelector('#modell .filter__data.modell .slider__data.active') ||
        document.querySelector('#modell .filter__data.modell .slider__data');
      const modelKey = activeModelTile ? '.' + activeModelTile.dataset.item : '';

      // Find active farbe
      const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
      const colorKey = activeColorTile ? '.' + activeColorTile.dataset.item : '';
      const muenzContainers = document.querySelectorAll('.muenzfach.filter__data');
      muenzContainers.forEach((c) => c.classList.remove('active'));
      if (modelKey && colorKey) {
        document.querySelectorAll('.muenzfach.filter__data' + modelKey + colorKey).forEach((c) => {
          c.classList.add('active')
        });
      }
    }

    const modelsRoot = document.querySelector("#modell");
    if (!modelsRoot) {
      console.warn("No #modell container found.");
      return;
    }

    // // IDs to match
    // const ALLOWED_IDS = new Set(["452180016171622", "45217982054666"]);

    // // handleModelClick to handle the click on models
    // function handleModelClick(e) {
    //   setTimeout(() => {
    //     const modelContainer = e.target.closest(".filter__data.modell.active");
    //     if (!modelContainer || !modelsRoot.contains(modelContainer)) return;

    //     // Prefer the active slider's image
    //     const img = modelContainer.querySelector(".slider__data.active img");

    //     if (!img) {
    //       console.warn("No image found inside the clicked model container.");
    //       return;
    //     }

    //     const dataId = img.getAttribute("data-id");

    //     if (ALLOWED_IDS.has(dataId)) {
    //       const modelFirstElement = document.querySelector(
    //         "#farbe .swiper-slide:first-child .slider__data"
    //       );
    //       if (modelFirstElement && !modelFirstElement.classList.contains("active")) {
    //         modelFirstElement.click();
    //       } else {
    //       }
    //     } else {
    //       const farbeRoot = document.querySelector("#farbe");
    //       if (!farbeRoot) {
    //         console.warn("⚠️ #farbe not found in DOM.");
    //         return;
    //       }

    //       // Find the image in farbe with matching data-id
    //       const matchImg = farbeRoot.querySelector(
    //         `.swiper-slide .slider__data img[data-id="${dataId}"]`
    //       );

    //       if (!matchImg) {
    //         console.warn("⚠️ No matching image in #farbe for data-id:", dataId);
    //         return;
    //       }

    //       // Click its closest .slider__data, but only if not already active
    //       const targetSliderData = matchImg.closest(".slider__data");
    //       if (!targetSliderData) {
    //         console.warn("⚠️ Matching image found but no .slider__data wrapper.");
    //         return;
    //       }

    //       if (!targetSliderData.classList.contains("active")) {
    //         targetSliderData.click();
    //       } else {
    //       }
    //     }
    //   }, 500);
    // }

    // // Use the function in the event listener
    // modelsRoot.addEventListener("click", handleModelClick);


    // Function to refresh a specific section of the page using AJAX
    // function refreshSection() {
    //   $.ajax({
    //     url: window.location.href, // Get the current page URL
    //     method: 'GET',
    //     success: function(response) {
    //       // Find the new content you want to replace and update it
    //       var newContent = $(response).find('.bd-quick-cart .bd-quick-cart__container .bd-quick-cart__content').html();
    //       $('.bd-quick-cart .bd-quick-cart__container .bd-quick-cart__content').html(newContent);
    //       const cartDrawer = document.querySelector('.bd-quick-cart');
    //       if (cartDrawer) cartDrawer.classList.add('is-open');
    //     },
    //     error: function() {
    //       console.log('Error refreshing content');
    //     }
    //   });

    // }

    async function refreshCartSectionForKonfigurator() {
      try {
        const res = await fetch('/cart?sections=bd-quick-cart_section');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        const html = data['bd-quick-cart_section'];
        const container = document.querySelector('#shopify-section-bd-quick-cart_section');

        if (container && typeof html === 'string') {
          container.innerHTML = html;

          // Open the cart drawer (taken from your jQuery version)
          const cartDrawer = document.querySelector('.bd-quick-cart');
          if (cartDrawer) cartDrawer.classList.add('is-open');
        }
      } catch (e) {
        console.error('Error refreshing cart section:', e);
      }
    }

    // Function to add the product to the cart using the variant ID
    function defaultAddToCart(formData) {
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(data => {
          // After successful cart addition, redirect to checkout page
          // window.location.href = '/checkout';
          // refreshSection();
          refreshCartSectionForKonfigurator();
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          alert(error);
          MainAddToCartButton.disabled = false;
        });
    }
    // Default ADD TO CART CART Button functionality ends


    const customAddToCartButton = document.querySelector('.custom-add-to-cart-btn-os');
    if (customAddToCartButton) {
      customAddToCartButton.addEventListener('click', () => {
        const root = customAddToCartButton.closest('.action-btns-os');
        // Find the corresponding form inside that root
        const form = root.querySelector('.action-btns-os form');
        if (!form) {
          console.warn('No form found next to this add-to-cart button.');
          return;
        }

        const idInput = form.querySelector('[name="id"]');

        if (!idInput) {
          console.warn('Variant ID input missing in form.');
          return;
        }

        const variantId = idInput.value;

        // Find the main product form
        const productForm = document.querySelector('form[action="/cart/add"]');

        if (productForm) {
          const formData = new FormData(productForm);

          // Find the product node
          const productNode = result.data.products.nodes.find(item =>
            item.variants.edges.find(variant => variant.node.id.endsWith(variantId))
          );

          if (!productNode?.productFeatureList) {
            defaultAddToCart(formData);
            return;
          }

          if (productNode?.productFeatureList?.references?.nodes) {
            const featureList = productNode.productFeatureList;

            let features = [];

            // Case 1: list of metaobjects
            if (featureList.references?.nodes?.length) {
              features = featureList.references.nodes;
            }
            // Case 2: single metaobject
            else if (featureList.reference) {
              features = [featureList.reference];
            }

            let idx = 0;
            for (const feature of features) {
              if (idx >= 2) break;

              // Extract text and icon
              const featureTextField = feature.fields.find(f => f.key === "feature_text");
              const featureIconField = feature.fields.find(f => f.key === "feature_icon");

              const text = featureTextField?.value || "";
              const icon = featureIconField?.reference?.image?.url || "";
              const alt = featureIconField?.reference?.image?.altText || "";

              const i = idx + 1;
              if (text) formData.append(`properties[_Feature_${i}_text]`, text);
              if (icon) formData.append(`properties[_Feature_${i}_icon]`, icon);
              if (alt) formData.append(`properties[_Feature_${i}_icon_alt]`, alt);

              idx++;
            }
          }

          defaultAddToCart(formData)
        }
      });
    }



    // Code to change Model image when select any color & Leather ends
    /* ===== Code-os ends ===== */




    const videoBtn = document.getElementById('videoBtn');
    if (videoBtn) {
      videoBtn.addEventListener('click', function () {
        toggleActive('videoBtn');
        if (vid.style.display === "none") {
          showAndHideSiblings(vid);

          // On mobile Chrome, if the src was recently changed via setAttribute+load(),
          // play() may fail because the video isn't ready yet.
          // Strategy: try play() immediately; if it rejects (or if readyState is too low),
          // wait for 'canplay' and try again once.
          function tryPlay() {
            const playPromise = vid.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                // First attempt failed — wait for canplay and retry once
                vid.addEventListener('canplay', function onCanPlay() {
                  vid.removeEventListener('canplay', onCanPlay);
                  vid.play().catch(() => {}); // silent fallback: user can tap natively
                }, { once: true });
              });
            }
          }

          if (vid.readyState >= 2) { // HAVE_CURRENT_DATA or better
            tryPlay();
          } else {
            // Not ready at all yet — wait for canplay first
            vid.addEventListener('canplay', function onCanPlay() {
              vid.removeEventListener('canplay', onCanPlay);
              tryPlay();
            }, { once: true });
          }
        } else {
          if (activeImageSide === 'frontSide') {
            handleFrontBackToggleClick(MAIN_SEL, FRONT_SEL, BACK_SEL, BACK_FRONT_BTN, 'frontImage');
          } else {
            handleFrontBackToggleClick(MAIN_SEL, FRONT_SEL, BACK_SEL, BACK_FRONT_BTN, 'muenzfach');
          }
        }
      });
    }

    const nextBtn = document.querySelector('.Konfigurator_next_btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const tabs = document.querySelectorAll('.tablinks');
        const activeTab = document.querySelector('.tablinks.active');
        if (!tabs.length || !activeTab) return;
        const currentIndex = Array.from(tabs).indexOf(activeTab);
        const nextTab = tabs[currentIndex + 1];

        if (nextTab && nextTab.getAttribute('tab_data') == 'muenzfach') {

          // setTimeout(() => { const btn = document.querySelector('#vorderseiteBtn'); if (btn) btn.click(); }, 500);
          nextBtn.style.display = 'none';
          // const cartBtn = document.querySelector('.cart__btn');
          const cartBtn = document.querySelector('.custom-add-to-cart-btn-os');
          if (cartBtn) cartBtn.style.setProperty('display', 'flex', 'important');
        }

        if (nextTab) {
          activeTab.classList.add('in-active');
          activeTab.classList.remove('active');
          nextTab.classList.add('active');
          nextTab.click();

          const newPaneId = nextTab.getAttribute('tab_data');
          const newPane = newPaneId ? document.getElementById(newPaneId) : null;
          if (newPane) setTimeout(() => {
            reorderSoldOutToEnd(newPane);
            refreshVisibleSwipers(newPane);
          }, 50);
        }
      });
    }
  }

  // [OPT-1] Extracted from the old setTimeout(1500): run defaults synchronously after DOM is painted
  async function initializeDefaults() {
    return new Promise((resolve) => {
      // Two rAF guarantees the DOM from updatemodel() is fully painted before we read it
      requestAnimationFrame(() => requestAnimationFrame(() => {
        try {
          const modellWrap = document.querySelector('#modell .filter__data.modell');
          if (!modellWrap) { resolve(); return; }

          const defaultVariantId = document.querySelector('.sdev_container_configrator')?.dataset.defaultVariantId;
          const farbeItem = document.querySelector(`img[data-id="${defaultVariantId}"]`)?.closest('.slider__data');

          if (farbeItem) {
            farbeItem.click();

            const activeColorTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
            const colorKey = activeColorTile ? '.' + activeColorTile.dataset.item : '';
            const muenzfachKey = farbeItem?.dataset.muenzfach || '';

            modellWrap.querySelectorAll('.slider__data').forEach((modelTile) => {
              const mk = modelTile.dataset.item;
              if (!mk) return;
              let sourceImg = null;
              document.querySelectorAll('.farbe.filter__data.' + mk).forEach((el) => {
                if (sourceImg) return;
                if (colorKey && muenzfachKey) {
                  const t1 = el.querySelector(`${colorKey}[data-muenzfach="${muenzfachKey}"] img`);
                  if (t1) { sourceImg = t1; return; }
                }
                if (colorKey) {
                  const t2 = el.querySelector(`${colorKey} img`);
                  if (t2) { sourceImg = t2; return; }
                }
                const t3 = el.querySelector('.swiper-slide:not(.remove) .slider__data img');
                if (t3) sourceImg = t3;
              });
              const targetImg = modelTile.querySelector('img');
              if (targetImg && sourceImg && targetImg.getAttribute('src') !== sourceImg.getAttribute('src')) {
                syncImgAttributes(targetImg, sourceImg);
              }
            });

            const modellItem = modellWrap.querySelector(`img[data-id="${defaultVariantId}"]`)?.closest('.slider__data');
            if (modellItem) modellItem.click();

            const activeModelTile = document.querySelector('#modell .filter__data.modell .slider__data.active') ||
              document.querySelector('#modell .filter__data.modell .slider__data');
            const modelKey = activeModelTile ? '.' + activeModelTile.dataset.item : '';

            const muenzContainers = document.querySelectorAll('.muenzfach.filter__data');
            muenzContainers.forEach((c) => c.classList.remove('active'));
            if (modelKey && colorKey) {
              document.querySelectorAll('.muenzfach.filter__data' + modelKey + colorKey).forEach((c) => c.classList.add('active'));
              document.querySelectorAll('.muenzfach.filter__data' + modelKey + colorKey).forEach((c) => {
                c.querySelector(`img[data-id="${defaultVariantId}"]`)?.closest('.slider__data')?.click();
              });
            }
          } else {
            clickFirstAvailable(modellWrap);
            applyBackwardsDefaults('modell');
          }
          reorderSoldOutToEnd();
        } catch (e) {
          console.error('initializeDefaults error:', e);
        }
        resolve();
      }));
    });
  }

  // -------------------------------- Main Boot --------------------------------
  async function bootKonfigurator() {
    _loader.start();
    _loader.setProgress(5);
    try {
      result = await fetchresult();          // network — heaviest step
      _loader.setProgress(40);

      if (result) {
        const data = filteredJsonData(result);
        await updatemodel(data);             // DOM build
        _loader.setProgress(55);

        await initializeDefaults();
        reorderSoldOutToEnd();
        updateModellAvailability();
        _loader.setProgress(68);

        await preloadAndSetMainPreview();
        _loader.setProgress(78);

        // Image loading: update progress as each image finishes
        await waitForInitialImages((loaded, total) => {
          _loader.setProgress(78 + Math.round((loaded / total) * 22));
        });
      }
    } catch (error) {
      console.error('Initialization error:', error);
    } finally {
      hideLoader();
      preloadAllVariantImages();
    }
  }

  // Reads the active variant's front-image URL, preloads it, and sets it on
  // .main-product-img synchronously so waitForInitialImages sees the final src.
  function preloadAndSetMainPreview() {
    return new Promise((resolve) => {
      const mainImg = document.querySelector('.main-product-img');
      if (!mainImg) return resolve();

      // Find active farbe tile → get its sku → look up data-Fimage in the select
      const activeFarbeTile = document.querySelector('.farbe.filter__data.active .slider__data.active');
      const sku = activeFarbeTile?.querySelector('img')?.dataset?.variantsku;
      const option = sku ? document.querySelector(`#konfigurator-variants option.${sku}`) : null;
      const frontUrl = option?.getAttribute('data-Fimage');

      if (!frontUrl) return resolve();

      // Cancel any pending loadImage() for mainImg (prevents the async one from overwriting)
      mainImg._loadToken = (mainImg._loadToken || 0) + 1;
      const token = mainImg._loadToken;

      const preloader = new Image();
      preloader.onload = () => {
        // Only apply if not superseded
        if (mainImg._loadToken === token) {
          mainImg.setAttribute('src', frontUrl);
        }
        resolve();
      };
      preloader.onerror = () => resolve(); // don't block loader on broken image
      preloader.src = frontUrl;
    });
  }

  window.addEventListener('load', () => {
    wireButtons(); 
    bootKonfigurator();
  });

  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', () => { wireButtons(); bootKonfigurator(); });
  // } else {
  // }
})();